import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';

import withStyles from "@material-ui/core/styles/withStyles";
import Grid from '@material-ui/core/Grid';

import HeaderLinks from "components/Header/HeaderLinks.jsx";

// core components
import Header from "../../components/Header/Header.jsx";
//import Footer from "components/Footer/Footer.jsx";
import FacetChip from '../../components/Article/common/FacetChip';
import SideBar from '../../components/Article/SideBar';
import imagesStyles from "assets/jss/material-kit-pro-react/imagesStyles.jsx";
import cardStyles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.jsx";
import { cardTitle } from "assets/jss/material-kit-pro-react.jsx";
import MediaQuery from 'react-responsive';

import NewsSearchBar from '../../components/Article/SearchBar';
import NewsFeed from '../../components/Article/MainFeed';
import GrantFeed from '../../components/Article/BannerFeed';

import { fetchNews, fetchFacetDetail } from '../../actions';
import { throttle, debounce } from 'throttle-debounce';

// Responsive filters drawer
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Divider from '@material-ui/core/Divider';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import AutoReload from "../../components/Autoreload/Autoreload";


const fieldsIntValues = ["staff_changes", "grants", "rfps", "advisories"];
const fieldHasCodeValue = fieldsIntValues.concat(["subjects", "pop_groups", "geos"]);

// const drawerWidth = 240;
const styles = theme => ({
    ...imagesStyles,
    ...cardStyles,
    cardTitle,
    RightAlign: {float: 'right'},
    candidLogo: {
        backgroundImage: 'url(https://candid.org/wp-content/themes/fc_wordpress_candid/images/candid.svg)',
        backgroundRepeat: 'no-repeat'
    },
    button: {
        paddingTop: '17px',
        borderRadius: 0,
        backgroundColor: '#000000'
    },
    mainContainer: {
        height: 'calc(100vh - 155px)',
        marginTop: '155px',

        "@media screen and (max-width: 600px)": {
            height: '0 !important',
            //marginTop: '268px !important'
            marginTop: '27px !important'
        },

        "@media screen and (min-width: 590px) and (max-width: 1200px)": {
            marginTop: 'calc(107px + 27px) !important'
            //marginTop: '27px !important'
        },
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
            width: 1100,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    mainFeaturedPost: {
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
        marginBottom: theme.spacing.unit * 4,
    },
    mainFeaturedPostContent: {
        padding: `${theme.spacing.unit * 6}px`,
        [theme.breakpoints.up('md')]: {
            paddingRight: 0,
        },
    },
    mainGrid: {
        float: 'right',
        width: '80%',
        marginTop: 0,
        "@media screen and (max-width: 1200px)": {
            margin: "0 auto",
            float: null,
            width: '100%'
        }
    },
    markdown: {padding: `${theme.spacing.unit * 3}px 0`},
    footer: {
        backgroundColor: theme.palette.background.paper,
        marginTop: theme.spacing.unit * 8,
        padding: `${theme.spacing.unit * 6}px 0`,
    },
    filtersDrawerBar: {
        top: 'auto',
        backgroundColor: '#febe10',
        color: '#000'
    },
    drawer: {
        // width: drawerWidth,
        width: '100%',
        maxWidth: '300px',
        flexShrink: 0,
    },
    drawerPaper: {
        // width: drawerWidth,
        width: '100%',
        maxWidth: '300px',
        top: 'none'
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        // padding: "20px",

        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
        backgroundColor: '#000'
    },
    drawerButton: {color: '#fff'}
});

class NewsArticlePage extends Component {
    constructor(props) {
        let queryStrings = {}
        super(props);

        this.props.location.search.replace('?', '&').split('&')
            .filter(p => p.length)  // remove empty string
            .map(d => {
                const params = d.split('=');
                queryStrings[params[0]] = params[1];
                return d;
            });

        let now = new Date();
        const today = this.formatDate(now);

        now.setDate(now.getDate() - 2);
        // const start = this.formatDate(now);
        const start = today;

        const decode = decodeURI,
            searchTerm = queryStrings.query ? decode(queryStrings.query) : '',
            searchDate = queryStrings.date ? decode(queryStrings.date) : (`${start} to ${today}`),
            geography = queryStrings.geos ? queryStrings.geos.replace(/,%20/, ";").split(',').map((term, i) => decode(term.replace(/;/, ', '))) : [];

        this.state = { 
            drawerOpen: false,
            searchTerm: searchTerm, 
            searchDate: searchDate,
            facets: {
                subjects: queryStrings.subjects ? queryStrings.subjects.split(',').map(decodeURI) : [],
                pop_groups: queryStrings.pop_groups ? queryStrings.pop_groups.split(',').map(decodeURI) : [],
                geos: geography,
                locations: queryStrings.locations ? queryStrings.locations.split(',').map(decodeURIComponent) : [],
                people: queryStrings.people ? queryStrings.people.split(',').map(decodeURIComponent) : [],
                organizations: queryStrings.organizations ?queryStrings.organizations.split(',').map(decodeURIComponent) : [],
                sources: queryStrings.sources ? queryStrings.sources.split(',').map(decodeURIComponent) : [],
                grants: queryStrings.grants ? queryStrings.grants.split(',').map((val, i) => parseInt(decodeURIComponent(val))) : [],
                rfps: queryStrings.rfps ? queryStrings.rfps.split(',').map((val, i) => parseInt(decodeURIComponent(val))) : [],
                staff_changes: queryStrings.staff_changes ? queryStrings.staff_changes.split(',').map((val, i) => parseInt(decodeURIComponent(val))) : [],
                advisories: queryStrings.advisories ? queryStrings.advisories.split(',').map((val, i) => parseInt(decodeURIComponent(val))) : [],
                data_sources: queryStrings.data_sources ? queryStrings.data_sources.split(',').map(decodeURIComponent) : []
            },
            options: {
                salience_sort: queryStrings.salience_sort ? decodeURI(queryStrings.salience_sort) === "true" : false,
                sort_reverse: queryStrings.sort_reverse ? decodeURI(queryStrings.sort_reverse) === "true" : false
            }
        };

        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleToggleSwitch = this.handleToggleSwitch.bind(this);
        this.handleSortReverse = this.handleSortReverse.bind(this);
        this.handleFacetAutoComplete = this.handleFacetAutoComplete.bind(this);
        this.handleFacetClick = this.handleFacetClick.bind(this);
        this.handleFacetRemove = this.handleFacetRemove.bind(this);
        this.autocompleteSearchDebounced = debounce(200, this.fetchAutoComplete);
        this.autocompleteSearchThrottled = throttle(500, this.fetchAutoComplete);

        this.filterMenuClick = this.filterMenuClick.bind(this);

        this.closeMenu = this.closeMenu.bind(this);
    }

    componentDidMount() {
        const { classes } = this.props;
        //do a search with empty string
        this.props.dispatch(fetchNews(this.state.searchTerm, this.state.searchDate, this.state.facets, this.state.options))

        const rotatingCards = document.getElementsByClassName(classes.cardRotate);
        for (let i = 0; i < rotatingCards.length; i++) {
            const rotatingCard = rotatingCards[i],
                cardWidth = rotatingCard.parentElement.offsetWidth,
                cardHeight = rotatingCard.children[0].children[0].offsetHeight;

            let rotatingWrapper = rotatingCard.parentElement,
                cardFront = rotatingCard.getElementsByClassName(classes.front)[0],
                cardBack = rotatingCard.getElementsByClassName(classes.back)[0];

            rotatingWrapper.style.height = cardHeight + "px";
            rotatingWrapper.style["margin-bottom"] = 30 + "px";

            cardFront.style.height = cardHeight + 35 + "px";
            cardFront.style.width = cardWidth + "px";

            cardBack.style.height = cardHeight + 35 + "px";
            cardBack.style.width = cardWidth + "px";
        }

    }

    formatDate(date) {
        let dd = date.getDate();
        let mm = date.getMonth() + 1; //January is 0!
        const yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        return `${yyyy}-${mm}-${dd}`;
    }

    fetchAutoComplete(searchTerm, searchDate, facet, value, dispatch) {
        dispatch(fetchFacetDetail(searchTerm, searchDate, facet, value, this.state.facets, this.state.options))
    }

    handleFacetAutoComplete(e, facet) {
        const val = e.target.value
        if (val) {
            if (val.length < 0) {
                this.autocompleteSearchThrottled(this.state.searchTerm, this.state.searchDate, facet, val, this.props.dispatch);
            } else {
                this.autocompleteSearchDebounced(this.state.searchTerm, this.state.searchDate, facet, val, this.props.dispatch);
            }
        }
    }

    handleValueChange(e) {}

    closeMenu() {
        this.setState({drawerOpen: false});
    }

    handleDateChange(e) {
        this.setState({ searchDate: `${this.formatDate(e[0])} to ${this.formatDate(e[1])}` });
        this.props.dispatch(fetchNews(this.state.searchTerm, this.state.searchDate, this.state.facets, this.state.options));
    }

    handleButtonFocus(e) {}

    handleToggleSwitch(e) {
        let options = this.state.options;
        options.salience_sort = !options.salience_sort;
        this.setState({ options: options });
        this.props.dispatch(fetchNews(this.state.searchTerm, this.state.searchDate, this.state.facets, this.state.options));
    }

    handleSortReverse(e) {
        let options = this.state.options;
        options.sort_reverse = !options.sort_reverse;
        this.setState({ options: options });
        this.props.dispatch(fetchNews(this.state.searchTerm, this.state.searchDate, this.state.facets, this.state.options));
    }

    handleSearch(e) {
        const term = document.getElementById("search").value;
        this.setState({ searchTerm: term });
        this.props.dispatch(fetchNews(term, this.state.searchDate, this.state.facets, this.state.options))
    }

    handleFacetClick(e, facet, value) {
        const facets = Object.assign({}, this.state.facets) || {},
            split = value ? value.split('||') : [],
            code = split && split.length > 2 ? split[2] : null;

        let val = split && split.length > 0 ? split[0] : '';
        if (code !== null && fieldHasCodeValue.indexOf(facet) > -1) {
            val = fieldsIntValues.indexOf(facet) > -1 ? parseInt(code) : code;
        }

        if (e.target && e.target.innerText === "") {
            this.handleFacetRemove(e, facet, val)
            return
        }
        facets[facet] = facets[facet] || [];
        if (value && facets[facet].indexOf(val) < 0)
            facets[facet] = facets[facet].concat(val);
        else
            return // already selected

        this.setState({ facets: facets });
        this.props.dispatch(fetchNews(this.state.searchTerm, this.state.searchDate, facets, this.state.options));
    }

    handleFacetRemove(e, facet, value) {
        const facets = Object.assign({}, this.state.facets) || {}, val = value && value.split ? value.split('||')[0] :  value
        facets[facet] = facets[facet] || []
        const index = facets[facet].indexOf(val)
        if (value !== undefined && index > -1) {
            facets[facet].splice(index, 1)
            this.setState({ facets: facets })
            this.props.dispatch(fetchNews(this.state.searchTerm, this.state.searchDate, facets, this.state.options))
        }
    }

    tagRender(onClick, facet, uiState, onRemove, allValues, classes) {
        return (p) => {
            let { tag, getTagDisplayValue } = p,
                split = getTagDisplayValue(tag).split('||'),
                key = split[0],
                isSelected = uiState && uiState.facets && uiState.facets[facet] && uiState.facets[facet].indexOf(key) > -1,
                currentObj = allValues.filter(f => f.name.substring(0, key.length) === key);

            const google_info = currentObj.length && currentObj[0].google_info ? currentObj[0].google_info : null;
            return <FacetChip key={key} props={{ classes, google_info, onClick, onRemove, isSelected, facet, ...p }} />
        }
    }

    filterMenuClick() {
        this.setState({ drawerOpen: !this.state.drawerOpen });
    }

    render() {
        const { classes, data, ...rest } = this.props,
            searchDate = this.state.searchDate,
            startDate = searchDate.split(' to ')[0],
            endDate = searchDate.split(' to ')[1];

        const now = new Date(), 
            utcNow = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());

        const results = data.fetchArticles.records,
            totalRecords = results && results.total_grant_records ? results.total_grant_records : null,
            subjectFilters = results && results.subject_filters ? results.subject_filters : null,
            totalarticleRecords = results && results.total_records ? results.total_records : null,
            queryTerm = results && results.q && results.q.trim().length ? results.q.replace(/\\"/g, '"') : '',
            isGrant = 1,
            isFetching = data.fetchArticles.isFetching,
            records = !(results && results.records) ? undefined : results.records,
            mainGridAttributes = {
                queryTerm,
                isFetching,
                records,
                isGrant: false,
                totalRecords: totalarticleRecords,
                subjectFilters: subjectFilters
            }

        return (

            <div>

                <Header
                    color="transparent"
                    brandComponent={
                        <NewsSearchBar 
                            startDate={startDate}
                            endDate={endDate}
                            handleSearch={this.handleSearch}
                            handleDateChange={this.handleDateChange}
                            handleValueChange={this.handleValueChange}
                            handleButtonFocus={this.handleButtonFocus}
                            isSwitchOn={this.state.options.salience_sort}
                            handleToggleSwitch={this.handleToggleSwitch}
                            reverseSort={this.state.options.sort_reverse}
                            handleSortReverse={this.handleSortReverse}
                        />

                    }
                    rightLinks={<HeaderLinks />}
                    fixed
                    changeColorOnScroll={{
                        height: 200,
                        color: "white"
                    }}
                    {...rest}
                />

                <div className={classes.mainContainer}>
                    {/* Only show on browsers with a min-width of 1200px */}
                    <MediaQuery minWidth={1200}>
                        <SideBar
                            data={data}
                            handleFacetAutoComplete={this.handleFacetAutoComplete}
                            handleFacetClick={this.handleFacetClick}
                            handleFacetRemove={this.handleFacetRemove}
                            state={this.state}
                        />
                    </MediaQuery>

                    <Grid container spacing={40} className={classes.mainGrid}>

                        {/* Experimental responsive filters */}
                        <MediaQuery maxWidth={1200}>
                            <AppBar id="mobile-filter-bar" position="fixed" className={classes.filtersDrawerBar}>
                                <Toolbar>
                                    <IconButton
                                        color="inherit"
                                        aria-label="open drawer"
                                        onClick={this.filterMenuClick}
                                        edge="start"
                                        // className={clsx(classes.menuButton, this.state.drawerOpen && classes.hide)}
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                </Toolbar>
                            </AppBar>
                            <Drawer 
                                className={classes.drawer} 
                                variant="temporary" 
                                anchor="left" 
                                open={this.state.drawerOpen}
                                onClose={this.closeMenu}
                                classes={{paper: classes.drawerPaper}}
                                // ModalProps={{
                                //     keepMounted: true, // Better open performance on mobile.
                                // }}
                            >
                                <div className={classes.drawerHeader}>
                                    <IconButton className={classes.drawerButton} onClick={this.filterMenuClick}>
                                        <ChevronLeftIcon />
                                    </IconButton>
                                </div>
                                <Divider />

                                <SideBar
                                    data={data}
                                    handleFacetAutoComplete={this.handleFacetAutoComplete}
                                    handleFacetClick={this.handleFacetClick}
                                    handleFacetRemove={this.handleFacetRemove}
                                    state={this.state}

                                    brandComponent={
                                        <NewsSearchBar 
                                            startDate={startDate}
                                            endDate={endDate}
                                            handleSearch={this.handleSearch}
                                            handleDateChange={this.handleDateChange}
                                            handleValueChange={this.handleValueChange}
                                            handleButtonFocus={this.handleButtonFocus}
                                            isSwitchOn={this.state.options.salience_sort}
                                            handleToggleSwitch={this.handleToggleSwitch}
                                            reverseSort={this.state.options.sort_reverse}
                                            handleSortReverse={this.handleSortReverse}
                                        />
                                    }
                                />
                            </Drawer>
                        </MediaQuery>

                        {/* Disable the grant feed for now */}
                        {/* // Only show on browsers with a min-width of 960px
                        // <MediaQuery minWidth={960}>
                        //     <GrantFeed 
                        //         data={{ 
                        //             totalRecords, 
                        //             queryTerm, 
                        //             isGrant, 
                        //             isFetching,
                        //             records: records ? records.filter(r => r.is_grant) : undefined, 
                        //             subjectFilters: subjectFilters 
                        //         }}
                        //         yesNoClick={this.handleYesNoClick}
                        //         utcStart={utcNow}
                        //     />
                        // </MediaQuery> */}
                        
                        <NewsFeed data={{ ...mainGridAttributes }} yesNoClick={this.handleYesNoClick} utcStart={utcNow} />
                    </Grid>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return { 
        data: state 
    }
}

NewsArticlePage.propTypes = {
    classes: PropTypes.object,
    location: PropTypes.object,
    data: PropTypes.object,
    queryTerm: PropTypes.string,
    isFetching: PropTypes.bool,
    records: PropTypes.array,
    dispatch: PropTypes.func,
    yesNoClick: PropTypes.func
}

const styledComponent = withStyles(styles)(NewsArticlePage);
export default connect(mapStateToProps)(styledComponent);



// WEBPACK FOOTER //
// ./src/views/NewsArticlesPage/NewsArticlesPage.jsx